import React, { useState } from 'react'
import { useDiagram } from '../DiagramContext'
import { useComponentPinout, useComponentFullPinout } from '../../BlockDiagram'
import PinoutTable from './PinoutTable'
import { useTools } from '../../hooks/RelatedContent'
import { useUserInfo } from '../../hooks/User'

const ConnectorFullPinout = ({ isAllPins, setIsAllPins, pageSize }) => {
  const { userInfo } = useUserInfo()
  const diagram = useDiagram()
  const isRelatedContentEnabled =
    (userInfo?.features?.related_content ?? false) &&
    diagram.blockDiagram.graph.selection === 'connector'
  const { isLoading, pinout } = useComponentFullPinout({
    vin: diagram.vin,
    componentId: diagram.blockDiagram.graph.data.componentId,
  })
  const { isLoading: toolsLoading, tools } = useTools({
    vin: diagram.vin,
    componentId: diagram.blockDiagram.graph.data.componentId,
    enabled: isRelatedContentEnabled,
  })
  return (
    <PinoutTable
      pinout={pinout}
      isLoading={isLoading}
      isAllPins={isAllPins}
      setIsAllPins={setIsAllPins}
      pageSize={pageSize}
      tools={tools}
      toolsLoading={toolsLoading}
    />
  )
}

const ConnectorSessionPinout = ({ isAllPins, setIsAllPins, pageSize }) => {
  const { userInfo } = useUserInfo()
  const diagram = useDiagram()
  const isRelatedContentEnabled =
    (userInfo?.features?.related_content ?? false) &&
    diagram.blockDiagram.graph.selection === 'connector'

  const { isLoading, pinout } = useComponentPinout({
    vin: diagram.vin,
    componentId: diagram.blockDiagram.graph.data.componentId,
    neighborIds: diagram.blockDiagram.graph.data.neighborIds,
  })
  const {
    isLoading: toolsLoading,
    isSuccess: toolsSuccess,
    tools,
  } = useTools({
    vin: diagram.vin,
    componentId: diagram.blockDiagram.graph.data.componentId,
    enabled: isRelatedContentEnabled,
  })
  return (
    <PinoutTable
      pinout={pinout}
      isLoading={isLoading}
      isAllPins={isAllPins}
      setIsAllPins={setIsAllPins}
      pageSize={pageSize}
      tools={tools}
      toolsLoading={toolsLoading}
    />
  )
}

const ConnectorPinout = ({ pageSize }) => {
  const [isAllPins, setIsAllPins] = useState(false)
  return isAllPins ? (
    <ConnectorFullPinout
      isAllPins={isAllPins}
      setIsAllPins={setIsAllPins}
      pageSize={pageSize}
    />
  ) : (
    <ConnectorSessionPinout
      isAllPins={isAllPins}
      setIsAllPins={setIsAllPins}
      pageSize={pageSize}
    />
  )
}

export default ConnectorPinout
